




























































import { Component, Vue, Watch, Prop } from "vue-property-decorator";

/**
 * Components
 */
import ShopItemListElement from "./ShopItemListElement.vue";

/**
 * Types
 */
import { Cart } from "../store";

/**
 * Composant de détails du contenu d'une commande (items).
 */
@Component({ components: { ShopItemListElement } })
export default class CartDetails extends Vue {
  /** Propriétés */
  @Prop()
  cart!: Cart;

  @Prop()
  isActionLoading!: boolean;

  @Prop()
  handleItemAdd!: (itemId: number) => Promise<void>;

  @Prop()
  handleItemRemove!: (itemId: number,formulaNum: number | null) => Promise<void>;

  /** Attributs */
  isLoading = false;

  /** Méthodes */
  async created() {}

  async SetElement() {}

  getSubItemsInLinelst(idenumber: number | null) {
    // cart.items.map(x=> {x.item.cashItemType !=2 && x.formulaNumber == item.formulaNumber})

    if (idenumber == null || idenumber == 0) {
      return '';
    }
    let ret: string = '';
    let firstline :boolean = true;
    for (let elem of this.cart.items) {
      if (elem.item.cashItemType != 2 && elem.formulaNumber == idenumber) {
        if (firstline == false){ret +=" + "}
        ret += elem.item.label;
        firstline =false;
      }

    }
    return ret;
  }
}
